"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionFailed = exports.ACTION_FAILED = void 0;
exports.ACTION_FAILED = 'ACTION_FAILED';
function actionFailed(reason) {
    return { type: exports.ACTION_FAILED, reason: reason };
}
exports.actionFailed = actionFailed;
